import {DiagramSyncModeType} from './enums';
import {DiagramSyncMode} from './interfaces';

/* 
    Режимы синхронизации графиков сигналов
*/
export const signalDiagramSyncModes: DiagramSyncMode[] = [
  {id: 1, name: 'Курсоры', type: DiagramSyncModeType.Cursors},
  {id: 2, name: 'Зум X', type: DiagramSyncModeType.ZoomX},
  {id: 3, name: 'Интервалы', type: DiagramSyncModeType.TimeIntervals},
];

/* 
    Режимы синхронизации графиков спектров
*/
export const spectrumDiagramSyncModes: DiagramSyncMode[] = [
  {id: 1, name: 'Курсоры', type: DiagramSyncModeType.Cursors},
  {id: 2, name: 'Зум X', type: DiagramSyncModeType.ZoomX},
];

/* 
    Режимы синхронизации для графика среднеквадратичного отклонения и водопада в вибродиагностике
*/
export const vibrationDiagnosticsWaterfallDiagramSyncModes: DiagramSyncMode[] = [
  {id: 1, name: 'Курсоры', type: DiagramSyncModeType.Cursors, preselected: true},
  {id: 2, name: 'Зум X', type: DiagramSyncModeType.ZoomX},
];
